restrictType.$inject = ['$filter'];


function restrictType ($filter) {
  var restrict = {
    num : {
      rest:/\d/,
      validate:/^[\d]*$/
    },
    numAmount:{
      rest:/[\d.]/,
      validate:/^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
    },
    numValues:{
      rest:/[\d.]/,
      validate:/^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
    },
    numDec:{
      rest:/[\d.]/,
      validate:/^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
    },
    numHours:{
      rest:/[\d.]/,
      validate:/^[0-9]+$|^\d*\.[0-5][0-9]$|^\d*\.[0-5]$/
    },
    numDec4:{
      rest:/[\d.]/,
      validate:/^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
    },
    numHund:{
      rest:/[\d.]/,
      validate:/^(100)\.0{1,}$|^(100)$|^([0-9]{1,2}\.\d{1,})$|^([0-9]{1,2})$/
    },
    //numHund99:{
    //    rest:/[\d.]/,
    //    validate:/^(99)\.0{1,}$|^(99)$|^([0-9]{1,2}\.\d{1,})$|^([0-9]{1,2})$/
    //},
    numDash:{
      rest:/[\d-]/,
      validate:/^[\d-]*$/
    },
    alfanumeric:{
      rest:/[\w]/,
      validate:/^[\w]*$/
    },
    date: {
      rest:/\d|[/]/,
      validate:/(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))/
    },
    email:{
      rest:/\w|\W/,
      // validate:/^(\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b)$/
      validate:/^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/i
    },
    numEleven:{
      rest:/\d/,
      validate:/^[0-9]$|^(1[0-1])$|^(0[0-9])$/
    }
  };


  return{
    restrict : 'A',
    require: 'ngModel',
    link: link
  };

  function link (scope, elem, attrs, ngModelCtrl){

    var restType = '',
      numAmountValue = 2,
      numValuesValue = 0;
    attrs.$observe('restrictType', function(value){
      restType = value;
    });

    elem.on('keypress', function(e) {
      //var k = document.all ? e.keyCode : e.which,
      var k = (e.which) ? e.which : e.keyCode,
        rend = '';
      if (k===8 || k===0 || k===9 || k===37 || k===39) return true;
      if(attrs.restrictType === "date"){
        if (k === 42||k === 43|| k === 44|| k === 45||k === 46){
          k = 47;
          var h = String.fromCharCode(k);
          if(!ngModelCtrl.$viewValue){
            rend = h;
          }else if(ngModelCtrl.$viewValue.length === 10){
            return false;
          }else{
            rend = ngModelCtrl.$viewValue + h;
          }
          ngModelCtrl.$setViewValue(rend);
          ngModelCtrl.$render();
          return false;
        }
      }

      if(attrs.restrictType === "numAmount" ||
        attrs.restrictType === "numValues" ||
        attrs.restrictType === "numDec" ||

        attrs.restrictType === "numHours" ||
        attrs.restrictType === "numHund" ||
        attrs.restrictType === "numDec4"){
        if (k === 46){
          var regex = /[.]/g;
          if (regex.test(ngModelCtrl.$viewValue)){
            return false;
          }
        }
      }
      var patron = restrict[restType].rest;
      var n = String.fromCharCode(k);
      return patron.test(n);
    });

    var decValue = 0;
    if(attrs.restrictType === "numAmount" ||
      attrs.restrictType === "numValues" ||
      attrs.restrictType === "numDec" ||
      attrs.restrictType === "numHours" ||
      attrs.restrictType === "numHund" ||
      attrs.restrictType === "numDec4"){

      if(attrs.restrictType === "numAmount")decValue = numAmountValue;
      if(attrs.restrictType === "numValues")decValue = numValuesValue;
      if(attrs.restrictType === "numDec" ||
        attrs.restrictType === "numHund" ||
        attrs.restrictType === "numHours") decValue = 2;
      if(attrs.restrictType === "numDec4" ) decValue = 4;

      elem.on('focus',function() {
        if(ngModelCtrl.$viewValue) {
          var newVal = ngModelCtrl.$viewValue.replace(/[,]/g, '');
          ngModelCtrl.$setViewValue(newVal);
          ngModelCtrl.$render();
        }
      });
      elem.on('blur', function() {
        console.log(attrs);
        if(elem[0].required) {
          if(parseFloat(ngModelCtrl.$viewValue)){
            if(setInvalidIfRequired(ngModelCtrl.$viewValue))return;
          }else{
            var valueReq = $filter('number')(0,decValue);
            ngModelCtrl.$setViewValue(valueReq);
            setInvalidIfRequired(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
            return;
          }
        }
        if (ngModelCtrl.$viewValue) {
          setErrorIfInvalid (ngModelCtrl.$viewValue);
        } else {
          var value = $filter('number')(0,decValue);
          ngModelCtrl.$setViewValue(value);
          setErrorIfInvalid (value);
          ngModelCtrl.$render();
          return;
        }
        var newVal = $filter('number')(ngModelCtrl.$viewValue,decValue);
        if (!newVal || newVal === "") return;
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      });
      ngModelCtrl.$formatters.unshift(function(value){
        if (angular.isString(value)) value = value.replace(/[,]/g, '');
        scope.$watch(function(){
          return elem[0].required;
        }, function(bool){
          if(bool){
            //if(elem[0].required){
            if(value){
              if(setInvalidIfRequired(value)){
                value = $filter('number')(value,decValue);
                return value ? value : null;
              }
            }
          }else{
            ngModelCtrl.$setValidity('morethanzero' , true);
            return value ? value : null;
          }
        });
        setErrorIfInvalid (value);
        value = $filter('number')(value,decValue);
        return value ? value : null;
      });
    } else if (attrs.restrictType === "date") {
      elem.on('blur', function() {
        if(ngModelCtrl.$viewValue){
          autocompleteDate();
          setErrorIfInvalid(ngModelCtrl.$viewValue);
        }
      });
      ngModelCtrl.$formatters.unshift(function (value){
        setErrorIfInvalid(value);
        return (value)?value:null;
      });
    } else if (attrs.restrictType === "email") {
      elem.on('blur', function() {
        if(ngModelCtrl.$viewValue){
          setErrorIfInvalid(ngModelCtrl.$viewValue);
        }else{
          ngModelCtrl.$setValidity('restEmail' , true);
        }
      });
      ngModelCtrl.$formatters.unshift(function (value){
        if(!value){
          ngModelCtrl.$setValidity('restEmail' , true);
          return value ? value : null;
        }
        setErrorIfInvalid(value);
        return value ? value : null;
      });
    } else {
      elem.on('blur change keyup', function() {
        if (ngModelCtrl.$viewValue){
          setErrorIfInvalid(ngModelCtrl.$viewValue);
        }
      });
      ngModelCtrl.$formatters.unshift(function (value){
        setErrorIfInvalid(value);
        return (value)?value:null;
      });
    }

    function setErrorIfInvalid (value){
      var isValid = true,
        error = "";
      if (!value) {
        isValid = true;
      } else {
        if (!attrs.restrictType)return;
        var regex = restrict[attrs.restrictType].validate;
        isValid= regex.test(value);
      }

      if (attrs.restrictType === "numAmount" || attrs.restrictType === "numValues" || attrs.restrictType === "numDec"){
        error = 'NumDec';
      } else if (attrs.restrictType === "numHund"){
        error ='hundred';
      } else if (attrs.restrictType === "num"){
        error ='Numeric';
      } else if (attrs.restrictType === "numDash"){
        error ='numDash';
      } else if (attrs.restrictType === "date"){
        error ='restDate';
      } else if (attrs.restrictType === "alfanumeric"){
        error ='alfanumeric';
      } else if (attrs.restrictType === "email"){
        error ='restEmail';
      } else if (attrs.restrictType === "numEleven"){
        error ='numEleven';
      } else if (attrs.restrictType === "numHours"){
        error ='numHours';
      }


      ngModelCtrl.$setValidity(error , isValid);//numHours
    }

    function setInvalidIfRequired(value){
      //var regex = /^0+?\.?0+$|^\.0+$/,
      //    isValid = regex.test(value);
      var isValid = (parseFloat(value)) ? false : true;
      ngModelCtrl.$setValidity('morethanzero' , !isValid);
      return isValid;
    }

    function autocompleteDate (){
      var newVal = '',
        regex1 = /(^[1-9](?=\/)(?![0123]))\//,
        regex2 = /\/([1-9](?=\/)(?![0123]))\//,
        regex3 =/\/(\d)[^\d]*$/,
        regex4 =/\/([0-2][0-9])[^\d]*$/,
        regex5 =/\/([3-9][0-9])[^\d]*$/,
        regex6 =/\/(\d\d\d)[^\d]*$/;

      if (regex1.test(ngModelCtrl.$viewValue)) {
        newVal = '0' + ngModelCtrl.$viewValue;
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      }
      if (regex2.test(ngModelCtrl.$viewValue)) {
        newVal = ngModelCtrl.$viewValue.slice(0,3)+ '0' + ngModelCtrl.$viewValue.slice(3);
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      }
      if (regex3.test(ngModelCtrl.$viewValue)) {
        newVal = ngModelCtrl.$viewValue.slice(0,6)+ '201' + ngModelCtrl.$viewValue.slice(-1);
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      }
      if (regex4.test(ngModelCtrl.$viewValue)) {
        newVal = ngModelCtrl.$viewValue.slice(0,6)+ '20' + ngModelCtrl.$viewValue.slice(6,8);
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      }
      if (regex5.test(ngModelCtrl.$viewValue)) {
        newVal = ngModelCtrl.$viewValue.slice(0,6)+ '19' + ngModelCtrl.$viewValue.slice(6,8);
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      }
      if (regex6.test(ngModelCtrl.$viewValue)) {
        console.log(ngModelCtrl.$viewValue);
        newVal = ngModelCtrl.$viewValue.slice(0,6)+ '2' + ngModelCtrl.$viewValue.slice(6,9);
        console.log(newVal);
        ngModelCtrl.$setViewValue(newVal);
        ngModelCtrl.$render();
      }
    }
  }
}

export default restrictType;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/restrict-type/restrict-type.js
 **/